import React from 'react';
import Sidebar from '../../../shared/components/layout/Sidebar';
import Cookies from 'js-cookie';
import Accounts from '../../../shared/assets/svg/accountsvg.svg';
import logo from '../../../shared/assets/svg/group.svg';
import liveFeed from '../../../shared/assets/png/liveFeed.svg';
import users from '../../../shared/assets/svg/users.svg';
import analytics from '../../../shared/assets/svg/analytics.svg';
import sales from '../../../shared/assets/svg/sales.svg';
import orgaisation from '../../../shared/assets/svg/organisation.svg';
import operations from '../../../shared/assets/svg/operations.svg';
import Reports from '../../../shared/assets/svg/reports.svg';
import Integration from '../../../shared/assets/svg/integration.svg';
import Logout from '../../../shared/assets/svg/logout.svg';
import SalesFlow from '../../../shared/assets/svg/SalesFlow.svg';
import Dashboard from '../../../shared/assets/svg/dashboardIcon.svg';
import inventory from '../../../shared/assets/svg/Inventory.svg';
import { Toaster } from 'react-hot-toast';
import { useSidebar } from '../../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import { useBuilderWhatsappIntegration } from '../../hooks/useBuilderWhatsappIntegration';
import { getUserById } from '../../services/api/implementation/impl';
import { syncSessionProfileFromUser } from '../../../shared/utils/authStorage';

const Layout = ({ children }) => {
  const userId = Cookies.get('userId');
  const { collapsed, setCollapsed } = useSidebar();

  const adminLinks = [
    { name: 'Dashboard', path: '/builder/dashboard', icon: Dashboard },
    {
      name: 'Management',
      path: '/builder/management',
      icon: orgaisation,
      children: [
        { displayName: 'Company', path: 'company' },
        { displayName: 'Land', path: 'land' },
        { displayName: 'Partner', path: 'partner' },
        // { displayName: 'Tasks', path: 'tasks' },
        { displayName: 'Universal Measurement', path: 'universal-measurement' }
      ]
    },
    {
      name: 'Sales',
      path: '/builder/sales',
      icon: sales,
      children: [
        // { displayName: 'Leads', path: 'sales' },
        { displayName: 'Performance', path: 'performance' },
        // { displayName: 'Targets & Incentives', path: 'targets-incentives' },
        // { displayName: 'Property Templates', path: 'propertyTemplates' },
        // { displayName: 'Unit Inventory', path: 'unit-inventory' },
        { displayName: 'Images', path: 'project-images' }
      ]
    },
    {
      name: 'Operations',
      path: '/builder/operations',
      icon: operations,
      children: [
        { displayName: 'Task Management', path: 'task-management' },
        { displayName: 'Create Tasks', path: 'tasks' },
        // { displayName: 'Accommodation & Blocks', path: 'accommodation-blocks' },
        // { displayName: 'Templates', path: 'templates' },
        // { displayName: 'Configure Holidays', path: 'configureHoliday' },
        { displayName: 'Service Providers', path: 'service-providers' },
        // { displayName: 'Change Requests', path: 'change-requests' },
        // { displayName: 'Management Tasks', path: 'managementTasks' }
      ]
    },
    {
      name: 'Inventory',
      path: '/builder/inventory',
      icon: inventory,
      children: [
        { displayName: 'Stock', path: 'stock' },
        { displayName: 'Vendors', path: 'vendors' },
        { displayName: 'Orders', path: 'orders' },
        { displayName: 'Machinery/Equipment', path: 'machinery' },
        { displayName: 'Materials', path: 'materials' },
        { displayName: 'Requirements', path: 'requirements' },
        { displayName: 'Monthly Report', path: 'monthly-report' },
        // { displayName: 'Consumption Report', path: 'consumption-report' },
        // { displayName: 'Escalation Report', path: 'escalation-report' }
      ]
    },

    {
      name: 'Marketing',
      path: '/builder/marketing',
      icon: SalesFlow,
      children: [
        { displayName: 'Dashboard', path: 'dashboard' },
        { displayName: 'Campaign/Forms', path: 'forms' },
        { displayName: 'Create Campaign', path: `add/campaign` },
        { displayName: 'Templates', path: `templates` },
        // WhatsApp Campaigns is injected in useMemo when integration is configured
        { displayName: 'Prelead List', path: 'prelead-lists' }
      ]
    },

    {
      name: 'Accounts',
      path: '/builder/accounts',
      icon: Accounts,
      children: [
        { displayName: 'Invoice', path: 'invoice' },
        { displayName: 'Payables', path: 'payables' },
        { displayName: 'Payables History', path: 'history' },
        { displayName: 'Priorities', path: 'priorities' },
        { displayName: 'Payment Stages', path: 'payment-stages' }
      ]
    },

    { name: 'Users', path: '/builder/users', icon: users },

    {
      name: 'Integration',
      path: '/builder/integration',
      icon: Integration
    },
    {
      name: 'Reports',
      path: '/builder/reports',
      icon: Reports,
      children: [
        { displayName: 'Sales Report', path: 'sales' },
        { displayName: 'Accounts Report', path: 'accounts' }
      ]
    },
    { name: 'Live Feed', path: '/builder/feed', icon: liveFeed },
    { name: 'Logout', path: 'logout', icon: Logout }
  ];

  const readSessionFromCookies = React.useCallback(
    () => ({
      userRole: Cookies.get('userRole'),
      userVertical: Cookies.get('userVertical'),
      userDesignationLevel: Cookies.get('userDesignationLevel')
    }),
    []
  );

  const [sessionMeta, setSessionMeta] = React.useState(readSessionFromCookies);

  React.useEffect(() => {
    const syncSessionMeta = () => setSessionMeta(readSessionFromCookies());
    window.addEventListener('userLoggedIn', syncSessionMeta);
    return () => window.removeEventListener('userLoggedIn', syncSessionMeta);
  }, [readSessionFromCookies]);

  React.useEffect(() => {
    let cancelled = false;

    const reconcileSessionProfile = async () => {
      const id = Cookies.get('userId');
      if (!id) return;

      try {
        const user = await getUserById(id);
        if (cancelled || !user) return;

        if (syncSessionProfileFromUser(user)) {
          setSessionMeta(readSessionFromCookies());
          window.dispatchEvent(new CustomEvent('sessionProfileSynced'));
        }
      } catch (error) {
        console.error('Failed to reconcile session profile:', error);
      }
    };

    reconcileSessionProfile();
    window.addEventListener('userLoggedIn', reconcileSessionProfile);

    return () => {
      cancelled = true;
      window.removeEventListener('userLoggedIn', reconcileSessionProfile);
    };
  }, [readSessionFromCookies, userId]);

  const { userRole, userVertical, userDesignationLevel } = sessionMeta;
  const { allowWhatsAppCampaignsSidebar } = useBuilderWhatsappIntegration();

  const filteredLinks = React.useMemo(() => {
    const vertical = userVertical?.toLowerCase();
    const designation = userDesignationLevel?.toLowerCase();

    const salesChildren = [
      // ...(vertical === 'management' ? [{ displayName: 'Dashboard', path: 'dashboard' }] : []),
      // { displayName: 'Leads', path: 'sales' },
      ...(designation === 'medium' || designation === 'high'
        ? [
          ...(vertical !== 'management'
            ? [{ displayName: 'Performance', path: 'performance' }]
            : []),
          // { displayName: 'Targets & Incentives', path: 'targets-incentives' },
          // { displayName: 'Property Templates', path: 'propertyTemplates' }
        ]
        : []),
      // { displayName: 'Unit Inventory', path: 'unit-inventory' },
      { displayName: 'Images', path: 'project-images' },
      // ...(vertical === 'sales' ? [{ displayName: 'Management Tasks', path: 'managementTasks' }] : [])
    ];

    const operationsChildren = [
      { displayName: 'Task Management', path: 'task-management' },
      { displayName: 'Create Tasks', path: 'tasks' },
      // { displayName: 'Accommodation & Blocks', path: 'accommodation-blocks' },
      // { displayName: 'Templates', path: 'templates' },
      // { displayName: 'Configure Holidays', path: 'configureHoliday' },
      { displayName: 'Service Providers', path: 'service-providers' },
      // { displayName: 'Change Requests', path: 'change-requests' },
      ...(vertical === 'operations' ? [{ displayName: 'Management Tasks', path: 'managementTasks' }] : [])
    ];

    const inventoryChildren = [
      { displayName: 'Stock', path: 'stock' },
      { displayName: 'Vendors', path: 'vendors' },
      { displayName: 'Orders', path: 'orders' },
      { displayName: 'Machinery/Equipment', path: 'machinery' },
      { displayName: 'Materials', path: 'materials' },
      { displayName: 'Requirements', path: 'requirements' },
      { displayName: 'Monthly Report', path: 'monthly-report' },
      // { displayName: 'Consumption Report', path: 'consumption-report' },
      // { displayName: 'Escalation Report', path: 'escalation-report' }
      // ...(vertical === 'inventory' ? [{ displayName: 'Management Tasks', path: 'managementTasks' }] : [])
    ];

    const accountsChildren = [
      { displayName: 'Invoice', path: 'invoice' },
      { displayName: 'Payables', path: 'payables' },
      { displayName: 'Payables History', path: 'history' },
      { displayName: 'Priorities', path: 'priorities' },
      ...(vertical === 'accounts'
        ? [
          { displayName: 'Payment Stages', path: 'payment-stages' },
        ]
        : [])
    ];

    const marketingChildren = [
      { displayName: 'Dashboard', path: 'dashboard' },
      { displayName: 'Campaign/Forms', path: 'forms' },
      { displayName: 'Create Campaign', path: 'add/campaign' },
      { displayName: 'Templates', path: 'templates' },
      ...(allowWhatsAppCampaignsSidebar
        ? [
            { displayName: 'WhatsApp Campaigns', path: 'whatsapp-campaigns' },
            { displayName: 'WhatsApp Flow', path: 'whatsapp-flow' }
          ]
        : []),
      ...(vertical !== 'management' ? [{ displayName: 'Prelead List', path: 'prelead-lists' }] : [])
    ];

    const modifiedAdminLinks = adminLinks.map((link) => {
      if (link.name === 'Sales') {
        return { ...link, children: salesChildren };
      }
      if (link.name === 'Operations') {
        return { ...link, children: operationsChildren };
      }
      if (link.name === 'Inventory') {
        return { ...link, children: inventoryChildren };
      }
      if (link.name === 'Accounts') {
        return { ...link, children: accountsChildren };
      }
      if (link.name === 'Marketing') {
        return { ...link, children: marketingChildren };
      }
      return link;
    });

    if (
      userRole === 'builder' &&
      vertical === 'sales' &&
      (designation === 'medium' || designation === 'high')
    ) {
      return modifiedAdminLinks.filter(
        (link) =>
          // link.name === 'Dashboard' ||
          link.name === 'Sales' ||
          link.name === 'Live Feed' ||
          link.name === 'Logout'
        // Users hidden for non-management verticals
        // || link.name === 'Users'
      );
    }

    switch (vertical) {
      case 'operations':
        return modifiedAdminLinks.filter(
          (link) =>
            link.name === 'Dashboard' ||
            link.name === 'Operations' ||
            link.name === 'Inventory' ||
            link.name === 'Live Feed' ||
            link.name === 'Logout'
          // Users hidden for non-management verticals
          // || link.name === 'Users'
        );
      case 'sales':
        // Only LOW designation reaches here (medium/high handled above)
        return modifiedAdminLinks.filter(
          (link) =>
            // link.name === 'Dashboard' ||
            link.name === 'Sales' ||
            link.name === 'Live Feed' ||
            link.name === 'Logout'
          // Users hidden for LOW designation
        );
      case 'accounts':
        return modifiedAdminLinks.filter(
          (link) =>
            link.name === 'Reports' ||
            link.name === 'Accounts' ||
            link.name === 'Live Feed' ||
            link.name === 'Logout'
        );
      case 'marketing':
        return modifiedAdminLinks.filter(
          (link) =>
            link.name === 'Marketing' ||
            link.name === 'Live Feed' ||
            link.name === 'Integration' ||
            link.name === 'Logout'
        );
      case 'inventory':
        return modifiedAdminLinks.filter(
          (link) =>
            link.name === 'Dashboard' ||
            link.name === 'Inventory' ||
            link.name === 'Live Feed' ||
            link.name === 'Logout'
        );
      case 'management':
        if (designation === 'medium' || designation === 'low') {
          return modifiedAdminLinks
            .filter(
              (link) =>
                link.name === 'Dashboard' ||
                link.name === 'Management' ||
                link.name === 'Live Feed' ||
                link.name === 'Logout'
            )
            .map((link) => {
              if (link.name !== 'Management') {
                return link;
              }
              return {
                ...link,
                children: link.children?.filter((child) => child.path === 'tasks')
              };
            });
        }
        return modifiedAdminLinks;
      default:
        return modifiedAdminLinks;
    }
  }, [userRole, userVertical, userDesignationLevel, allowWhatsAppCampaignsSidebar]);

  return (
    <div className="flex justify-between items-stretch relative min-h-screen">
      {/* Sidebar */}
      <Sidebar
        role="builder"
        links={filteredLinks}
        logo={logo}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />

      {/* Main content outlet */}
      <div
        className={`flex-1 bg-gray-100 min-h-screen absolute top-0
          transition-all duration-300 ease-in-out
          ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
          md:${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
        `}>
        {children}
      </div>

      <Toaster position="top-right" />
    </div>
  );
};

export default Layout;
